<template style="width: auto; background-color:">
  <md-dialog class="successDialog" :md-active.sync="options.showSuccessHtml">
    <md-dialog-content style="padding-top: 55px; padding-left: 40px; padding-bottom: 30px;" class="pt-40;"
      v-html="options.successMsgHtml"></md-dialog-content>
    <md-dialog-actions class="">
      <div class="pr-30 pb-40">
        <md-button class="md-raised secondary" @click="options.showSuccessHtml = false">{{ options.Lang.schließen }}</md-button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>
  
<script>
export default {
  name: 'successDialogHtml',
  props: {
    options: {
      type: Object,
      required: true
    },
  },
  data: () => ({
  })
}
</script>
  
<style lang="scss" scoped>
.successDialog {
  max-width: 600px !important;
  width: 600px !important;
  margin: 0 auto;
  font-size: 16px;
  padding-bottom: 100px;
}
</style>